<?xml version="1.0"?>
<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
  <rect fill="none" height="256" width="256" />
  <circle cx="64" cy="192" r="24" stroke="#fff" stroke-linecap="round"
    stroke-linejoin="round" stroke-width="16" />
  <circle cx="192" cy="64" r="24" stroke="#fff" stroke-linecap="round"
    stroke-linejoin="round" stroke-width="16" />
  <line stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"
    x1="175" x2="81" y1="81" y2="175" />
</svg>